<template>
  <div>
    <TradeDetailForm
      :is_user_content="is_user"
      v-if="trade_detail_form.flag"
      :trade_detail_form="trade_detail_form"
    ></TradeDetailForm>
  </div>
</template>

<script>
import TradeDetailForm from "@/components/Trade/TradeDetailForm.vue";
import { isAuthenticated } from "@/common/commonFunctions.js";
// import pupeteer from "pupeteer";

export default {
  name: "ShareTrade",
  components: {
    TradeDetailForm,
  },
  data: () => ({
    trade_detail_form: {
      flag: false,
      id: null,
    },
  }),
  methods: {
    // generateSS(){    // Require Puppeteer module
    //     const url = `https://covesto.in/trade/${this.trade_detail_form.id}/`;           // Set website you want to screenshot
    //     const Screenshot = async () => {                // Define Screenshot function
    //       const browser = await puppeteer.launch();    // Launch a "browser"
    //       const page = await browser.newPage();        // Open a new page
    //       await page.goto(url);                        // Go to the website
    //       await page.waitForSelector('.card');          // Method to ensure that the element is loaded
    //       const logo = await page.$('.card');        // logo is the element you want to capture
    //       await logo.screenshot({
    //         path: 'testImage.png'
    //         });
    //       await page.screenshot({                      // Screenshot the website using defined options
    //         path: "./screenshot.png",                   // Save the screenshot in current directory
    //         fullPage: true                              // take a fullpage screenshot
    //       });
    //       await page.close();                           // Close the website
    //       await browser.close();                        // Close the browser
    //     }               // Define Screenshot function
    //     console.log(Screenshot, 'this was ')
    // }
  },
  mounted() {
    this.trade_detail_form.flag = true;
    this.trade_detail_form.id = this.$route.params.id;
    console.log(this.trade_detail_form, this.$route.params.id);
    this.generateSS();
  },
  computed: {
    is_user: function () {
      console.log(isAuthenticated);
      return isAuthenticated();
    },
  },
};
</script>

<style scoped lang="scss"></style>
